<template>
  <div>
    <el-drawer v-model="model" :size="anchoSidebar" header-class="py-1 bg-primary text-white"
      footer-class="bg-dark text-white" @open="inicializarVisor()" body-class="d-flex justify-content-center">
      <template #header>
        <section class="d-flex align-items-center">
          <h3 class="text-center text-white">{{titulo}}</h3>
        </section>
      </template>

      <pdf
        v-if="showPdf && url"
        :key="pdfKey"
        :src="url"
        show-progress
        ref="refVisor"
        :page="1"
        style="width: 419.53pt;height: 595.28pt;"
      />

      <template #footer>
        <section class="w-100 d-flex">
          <b-button-group size="sm">
            <b-button v-for="(opcion,i) in opciones"  v-bind="opcion.btnOptions" :key="i">
              <font-awesome-icon :icon="opcion.icon" />
              {{ opcion.titulo }}
            </b-button>
            <a class="btn btn-link text-white" :href="url" download target="_blank">
              <font-awesome-icon icon="fas fa-download" />
              Descargar
            </a>
            <b-button @click="model = false" variant="outline-primary" class="text-white">
              <font-awesome-icon icon="fas fa-times" />
              Cerrar
            </b-button>
          </b-button-group>
        </section>
      </template>
    </el-drawer>
  </div>
</template>

<script setup>

import useAppStore from '@/store/app';


import pdf from "pdf-vue3";
import { nextTick } from 'vue';
const app_store = useAppStore();
const { anchoSidebar } = storeToRefs(app_store);


const model = defineModel({
  type: Boolean,
  default: false,
});

const props = defineProps({
  url: String,
  titulo:{
    type: String,
    default: 'Visor PDF'
  },
  opciones:{
    type:Array,
    required:false,
    default: () => ([])
  }
});

const refVisor = ref(null);
// key para forzar re-render del componente pdf cuando la url cambia
const pdfKey = ref(0);
// controla el montado/desmontado explícito del componente pdf
const showPdf = ref(false);

const {url} = toRefs(props);

const inicializarVisor = () => {
  // Desmontar y volver a montar para forzar carga limpia
  showPdf.value = false;
  nextTick(() => {
    pdfKey.value++; // cambia la key para garantizar nuevo ciclo
    showPdf.value = true;
  });
};



// Cuando cambia la URL del PDF
watch(url, (nuevo, anterior) => {
  if (nuevo && nuevo !== anterior && model.value) {
    inicializarVisor();
  }
});

// Cuando se abre/cierra el drawer (model controla el <el-drawer>)
watch(model, (abierto) => {
  if (abierto) {
    // montar nuevamente el pdf para refrescar (incluso si la url es la misma)
    inicializarVisor();
  } else {
    // al cerrar lo desmontamos
    showPdf.value = false;
  }
});

// Si ya viene abierto (caso inicial) y hay url
if (model.value && url.value) {
  inicializarVisor();
}

const headers = {
  Authorization: 'Bearer ' + localStorage.getItem('token'),
  'withCredentials':true,
  "Access-Control-Allow-Origin": "*",
  "X-Requested-With": "XMLHttpRequest",
  // // Accept: 'application/json',
  mode: "cors",
}
</script>

<style lang="scss" scoped>

</style>